import { Epic, combineEpics } from 'redux-observable';
import { isOfType, action } from 'typesafe-actions';
import { filter, mergeMap } from 'rxjs/operators';
import { of } from 'rxjs';

import { IRootAction, IRootState } from 'reducers';
import { ActionTypes } from 'reducers/app';

const watchLocationChange: Epic<IRootAction, IRootAction> = (action$, state$) =>
  action$.pipe(
    filter(isOfType('@@router/LOCATION_CHANGE')),
    mergeMap(({ payload: { location } }) => {
      const actions: any = [action(ActionTypes.HIDE_SIDEBAR)];
      return of(
        ...actions,
      );
    }),
  );

const watchToastrAdd: Epic<IRootAction, IRootAction, IRootState> = (action$, state$) =>
  action$.pipe(
    filter(isOfType('@ReduxToastr/toastr/ADD')),
    mergeMap(() => {
      const toastrs = state$.value.toastr.toastrs;
      const actions: any = [];
      if (toastrs.length > 2) {
        actions.push(action('@ReduxToastr/toastr/REMOVE', toastrs[toastrs.length - 1].id));
      }
      return of(
        ...actions,
      );
    }),
  );

export default combineEpics(
  watchLocationChange,
  watchToastrAdd,
);
